const doc = [({"en":({"js":({"admin":({"users":({"passwords":({"edit":({"change_your_password":"Change your password"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;